import React from 'react';
import Alert from '@mui/material/Alert';
import Typography from '@mui/material/Typography';
import Chip from '@mui/material/Chip';
import Box from '@mui/material/Box';
import AddIcon from '@mui/icons-material/AddRounded';
import { FlexColumn } from 'src/components/flex';

type Props = {
    newLabels: string[];
    existingLabels: string[];
    onRemoveLabel: (label: string) => void;
    onAddLabel: (label: string) => void;
    removedLabels: string[];
};

export default function ImportPropertiesLabel({
    newLabels,
    existingLabels,
    onRemoveLabel,
    onAddLabel,
    removedLabels,
}: Props) {

    return (
        <FlexColumn rowGap={2}>
            <Alert severity="info">
                Found {newLabels.length + existingLabels.length} unique label(s) in your CSV.
                {newLabels.length > 0 && ` ${newLabels.length} new label(s) will be created.`}
            </Alert>

            {newLabels.length > 0 && (
                <FlexColumn rowGap={1}>
                    <Box display="flex" alignItems="center" gap={1}>
                        <Typography variant="caption" fontWeight="bold" color="text.secondary" >
                            NEW LABELS
                        </Typography>
                        <Chip
                            label={`${newLabels.length} NEW`}
                            color="primary"
                            size="small"
                            sx={{color: 'white'}}
                        />
                    </Box>
                    <Box display="flex" flexWrap="wrap" gap={1}>
                        {newLabels.map((label) => (
                            <Chip
                                key={label}
                                label={label}
                                color="primary"
                                variant="outlined"
                                onDelete={() => onRemoveLabel(label)}
                            />
                        ))}
                    </Box>
                </FlexColumn>
            )}
            {removedLabels.length > 0 && (
                <FlexColumn rowGap={1}>
                    <Typography variant="caption" fontWeight="bold" color="text.secondary" >
                        REMOVED LABELS ({removedLabels.length})
                    </Typography>
                    <Box display="flex" flexWrap="wrap" gap={1}>
                        {removedLabels.map((labelName) => (
                            <Chip
                                key={labelName}
                                label={labelName}
                                variant="outlined"
                                onDelete={() => onAddLabel(labelName)}
                                deleteIcon={<AddIcon />}
                                sx={{
                                    backgroundColor: '#f5f5f5',
                                    borderColor: '#e0e0e0',
                                    color: 'text.primary',
                                }}
                            />
                        ))}
                    </Box>
                </FlexColumn>
            )}
            {existingLabels.length > 0 && (
                <FlexColumn rowGap={1}>
                    <Typography variant="caption" fontWeight="bold" color="text.secondary" >
                        EXISTING LABELS ({existingLabels.length})
                    </Typography>
                    <Box display="flex" flexWrap="wrap" gap={1}>
                        {existingLabels.map((labelName) => (
                            <Chip
                                key={labelName}
                                label={labelName}
                                variant="outlined"
                                sx={{
                                    backgroundColor: '#f5f5f5',
                                    borderColor: '#e0e0e0',
                                    color: 'text.primary',
                                }}
                            />
                        ))}
                    </Box>
                </FlexColumn>
            )}
        </FlexColumn>
    );
}
